import * as React from 'react'
import { CollectionsContext } from './Context'

export const useCollectionsContext = () => React.useContext(CollectionsContext)
